import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { CustomHttpResponse } from '../model/custom-http-response';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsUserService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAnalyticsCardUser(
    noCache: boolean | null,
    cardId: string | null
  ): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (noCache) {
      params = params.set('noCache', noCache);
    }
    if (cardId) {
      params = params.set('cardId', cardId);
    }
    return this.http.get<CustomHttpResponse>(`${this.host}/analytics/user/card/overview`, {
      observe: 'response',
      params,
    });
  }
  getAnalyticsPerMonth(
    from: string | null,
    to: string | null,
    cardId: string | null
  ): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (from) {
      params = params.set('from', from);
    }
    if (to) {
      params = params.set('to', to);
    }
    if (cardId) {
      params = params.set('cardId', cardId);
    }
    return this.http.get<CustomHttpResponse>(`${this.host}/analytics/user/card/graph`, {
      observe: 'response',
      params,
    });
  }
}
